module.exports = __webpack_public_path__ + "img/logo_white.07d8365b.svg";